import React from "react";
import pbsSlackPreview from '../assets/images/pbs-wi-slack-assistant-preview.png';
import badgerPreview from '../assets/images/project2-1.png';
import subadgerPreview from '../assets/images/subadger-preview.png';
import '../assets/styles/Project.scss';

const PBS_BOT_REPO = 'https://github.com/Jungwoo-Ryu/PBSBot';
const BADGER_REPO = 'https://github.com/Jungwoo-Ryu/badger-market-app';
const SUBADGER_REPO = 'https://github.com/Jungwoo-Ryu/subadger';

function Project() {
    return(
    <div className="projects-container" id="projects">
        <h1>Featured Projects</h1>
        <div className="projects-grid">
            <div className="project">
                <a href={PBS_BOT_REPO} target="_blank" rel="noreferrer" className="project-thumb-wrap">
                    <img src={pbsSlackPreview} className="zoom project-thumb-img" alt="PBS Wisconsin Assistant Slack bot" />
                </a>
                <a href={PBS_BOT_REPO} target="_blank" rel="noreferrer"><h2>PBS Wisconsin · RAG Slack Assistant</h2></a>
                <p className="project-meta"><strong>Role:</strong> AI Engineer · <strong>Stack:</strong> Python, Docker, ChromaDB, Ollama, Slack API, PyAirtable</p>
                <p className="project-desc">Topic menus and forms in Slack; RAG over Airtable into ChromaDB with a local Ollama model for grounded, natural-language answers.</p>
            </div>
            <div className="project">
                <a href={BADGER_REPO} target="_blank" rel="noreferrer" className="project-thumb-wrap">
                    <img src={badgerPreview} className="zoom project-thumb-img" alt="Badger Market" />
                </a>
                <a href={BADGER_REPO} target="_blank" rel="noreferrer"><h2>Badger Market</h2></a>
                <p className="project-meta"><strong>Role:</strong> Full-stack Engineer · <strong>Stack:</strong> Flutter, Firebase</p>
                <p className="project-desc">Campus second-hand marketplace—listings, in-app chat, and meetups. @wisc.edu verification keeps the community UW-only.</p>
            </div>
            <div className="project">
                <a href={SUBADGER_REPO} target="_blank" rel="noreferrer" className="project-thumb-wrap">
                    <img src={subadgerPreview} className="zoom project-thumb-img" alt="subadger Swipe Lease" />
                </a>
                <a href={SUBADGER_REPO} target="_blank" rel="noreferrer"><h2>subadger (Swipe Lease)</h2></a>
                <p className="project-meta"><strong>Role:</strong> PM (LikeLion WI) · <strong>Stack:</strong> FastAPI, RN Expo, TypeScript, Supabase, Docker</p>
                <p className="project-desc">Swipe-based sublease discovery—cards with rent, beds/baths, and dates; like/pass; Explore, Likes, Chat, and Profile flows.</p>
            </div>
        </div>
    </div>
    );
}

export default Project;
